import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import './styles.scss'
const bc = 'content-section'

const ContentSection = ({ title, children, isLastSection }) => (
  <div
    className={cn(`${bc}__wrapper`, {
      [`${bc}__last-section`]: isLastSection,
    })}
  >
    {title && <h3 className={`${bc}__title`}>{title}</h3>}
    <div className={`${bc}__content`}>{children}</div>
  </div>
)

ContentSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  isLastSection: PropTypes.bool,
}

export default ContentSection
